import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const bookDeliveryDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "request-delivery",
        action: "start",
        section: "pop-up",
        type: "",
        value: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default bookDeliveryDataPush;
